export default __webpack_public_path__ + "static/android-e02716047d09de40bab547a7ad05c631.png";